import { EnumIdvMethod } from '@wallet-manager/pfh-pmp-node-def-types/dist/src/DbModel/Master';

export const getIdvMethodDisplayValue = (
  value: number | undefined,
  translateFunc: (key: string) => string
) => {
  if (value === undefined || !EnumIdvMethod[value]) return '';

  return translateFunc(`EnumIdvMethod.${EnumIdvMethod[value]}`);
};
